import { Injectable } from '@angular/core';
import { AuthDtoSignerService } from '@damofire/data-security';
import { QuoteRequest } from './quote-request.dto';
import { logger, WH_QUOTE_REQUESTS_COLLECTION } from '@damofire/data-commons';
import { SavedSearch } from '../saved-search/saved-search.dto';
import { firestore } from 'firebase-admin';
import { Division, Organization } from '@damofire/data-stas';
import WhereFilterOp = firestore.WhereFilterOp;

@Injectable()
export class QuoteRequestService {
  constructor(private readonly dtoSigner: AuthDtoSignerService) {}
  async create(quoteRequest: QuoteRequest): Promise<void> {
    logger.info('Creating quote request', { category: 'quote' });
    await this.dtoSigner.add(quoteRequest, WH_QUOTE_REQUESTS_COLLECTION);
  }
}
export const buildQuoteRequestSavedSearch = (issueIds: string[], division: Division, organization: Organization): Partial<SavedSearch> => {
  const filtersOps = [{ field: '_id', op: 'in' as WhereFilterOp, value: [].concat(issueIds) }];
  return {
    type: 'issues',
    query: {
      searchPhrase: null,
      from: 0,
      size: issueIds.length,
      sort: {
        warehouseIssueId: 'desc',
      },
      filters: {
        'division._id': division._id,
      },
      filtersOps,
    },
    division: division,
    organization: organization,
    system: false,
    name: null,
    hidden: true,
  };
};
